export default "__VITE_ASSET__3938eaf4__"